import { useRef, useCallback } from 'react';
export function useRegisterFlipChild() {
  var registeredChildren = useRef(new Set());
  var registerChild = useCallback(function (fns) {
    registeredChildren.current.add(fns);
  }, []);
  var unregisterChild = useCallback(function (fns) {
    registeredChildren.current.delete(fns);
  }, []);
  return {
    registeredChildren: registeredChildren,
    registerChild: registerChild,
    unregisterChild: unregisterChild
  };
}